module.exports = __webpack_public_path__ + "pin_green_bs.22d3c3.png";